var Location = {
	getLocation: function() {
		return window.location;
    }    
};

module.exports = Location;